import { createContext } from 'react';

import { Rule } from '@totem/components/rulesEngine/types';

interface Context {
  rule: Rule | null;
  loading: boolean;
  notFound: boolean;
  onRefresh: () => void;
}

export default createContext<Context>({
  rule: null,
  loading: false,
  notFound: false,
  onRefresh: () => {},
});
